/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useMemo, useState, useEffect} from 'react'
import { Tooltip } from 'bootstrap'
import {saveAs} from 'file-saver'
import * as XLSX from 'xlsx'
import Papa from 'papaparse'
import {KTSVG, useDebounce} from '../../../helpers'
import {listSessionVR} from '../../../../api/sessionVRApi'
import {ViewDetailsSessionVR} from '../../modals/view-details-sessionvr/ViewDetailsSessionVR'
import {EditSessionVRAperta} from '../../modals/edit-sessionvr/EditSessionVRAperta'
import {DeleteSessionVR} from '../../modals/delete-sessionvr/DeleteSessionVR'
import {GenerateReport} from '../../modals/generate-report/GenerateReport'
import {EndSessionVRAndGenerateReport} from '../../modals/end-sessionvr-and-generate-report/EndSessionVRAndGenerateReport'
import {detailsReport} from '../../../../api/sessionVRApi'
import {ExportSessionsVRModal} from './Esportatori/EsportaSessioniVR'
import {UsersListSearchComponent} from '../../../../app/modules/apps/user-management/users-list/components/header/UsersListSearchComponent'
import {UsersListPagination} from '../../../../app/modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import { useAuth } from '../../../../app/modules/auth/core/Auth'
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import './StoricoSessioniVRWidget.css';
import caskyBase64 from './caskyBase64';

import dayjs from 'dayjs';
import 'dayjs/locale/it';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);
dayjs.locale('it');

interface MyData {
  ID_Sessione_VR: string
  Nome_formatore: string
  Cognome_formatore: string
  Discenti_associati: number
  Numero_partecipanti: number
  Data_inizio: string
  Terminata: boolean
  Stato: string
}

type SortConfig = {
  key: keyof MyData;
  direction: 'asc' | 'desc';
};

type Props = {
  className: string
}

const StoricoSessioniVRWidget: React.FC<Props> = ({className}) => {
  const {currentUser, logout} = useAuth()
  const user = currentUser as any;

  const [data, setData] = useState<MyData[]>([]);
  const [filteredData, setFilteredData] = useState<MyData[]>([]); // New state for filtered data
  const [searchTerm, setSearchTerm] = useState<string>(''); // New state for search term
  const debouncedSearchTerm = useDebounce(searchTerm, 150); // Debounce search term
  const [sortConfig, setSortConfig] = useState<SortConfig>({ key: 'Data_inizio', direction: 'desc' });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Numero di elementi per pagina

  const start = (currentPage - 1) * itemsPerPage;
  const end = start + itemsPerPage;

  const [showModal, setShowModal] = useState(false);
  const [showEditModal2, setShowEditModal2] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showGenerateReportModal, setShowGenerateReportModal] = useState(false);
  const [showEndSessionVRAndGenerateReportModal, setShowEndSessionVRAndGenerateReportModal] = useState(false);
  const [sessionvrStatus, setSessionvrStatus] = useState<string>('Aperta');

  const [showExportSessionsVRModal, setShowExportSessionsVRModal] = useState(false);
  const [exportStatus, setExportStatus] = useState<string>('Tutti');

  const [selectedRecordId, setSelectedRecordId] = useState<string | null>(null);
  const [selectedTerminata, setSelectedTerminata] = useState<boolean>(false);

  const sortedData = useMemo(() => {
    return [...filteredData].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [filteredData, sortConfig]);

  const handleRowClick = (action: string, recordId: string, terminata: boolean) => {
    setSelectedRecordId(recordId);
    setSelectedTerminata(terminata);
    if(action === 'view-details') {
      setShowModal(true);
    } else if(action === 'edit-sessionvr' && sessionvrStatus === 'Aperta') {
      setShowEditModal2(true);
    } else if(action === 'delete-sessionvr') {
      setShowDeleteModal(true);
    } else if(action === 'end-sessionvr-and-generate-report' && sessionvrStatus === 'Aperta') {
      setShowEndSessionVRAndGenerateReportModal(true);
    } else if(action === 'generate-report' && sessionvrStatus === 'Chiusa') {
      setShowGenerateReportModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCloseEditModal2 = () => {
    setShowEditModal2(false);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleCloseGenerateReportModal = () => {
    setShowGenerateReportModal(false);
  };

  const handleCloseEndSessionVRAndGenerateReportModal = () => {
    setShowEndSessionVRAndGenerateReportModal(false);
  };

  const [stateCounts, setStateCounts] = useState<{ [key: string]: number }>({});
  const [allData, setAllData] = useState<MyData[]>([]);

  const fetchData = async () => {
    try {
      let response = await listSessionVR(user.ID_User);

      for (let i = 0; i < response.length; i++) {
        let Data_inizio_US = dayjs(response[i].Data_inizio);
        response[i].Data_inizio = Data_inizio_US.format('DD/MM/YYYY');

        if(response[i].Terminata)
        {
          response[i].Stato = "Chiusa"
        }
        else
        {
          response[i].Stato = "Aperta"
        }
      }
  
      // Calcola il conteggio per ogni stato
      const counts: { [key: string]: number } = {};
      response.forEach((sessionVR: MyData) => {
        counts[sessionVR.Stato] = (counts[sessionVR.Stato] || 0) + 1;
      });
  
      // Imposta i conteggi
      setStateCounts(counts);

      // salva TUTTI i dati prima del filtro
      setAllData(response);
  
      const filteredResponse =
      sessionvrStatus !== null
        ? response.filter((sessionVR: MyData) => sessionVR.Stato === sessionvrStatus)
        : response;
  
      // Imposta i dati
      setData(filteredResponse);
      
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [sessionvrStatus]);

  // useEffect per gestire la barra di ricerca
  useEffect(() => {
    if (debouncedSearchTerm) {
      const lowerCasedSearchTerm = debouncedSearchTerm.toLowerCase();
      const filtered = data.filter(order => {
        return Object.values(order).some(val => {
          if (val !== null && typeof val === 'string') {
            return val.toLowerCase().includes(lowerCasedSearchTerm);
          }
          return false;
        });
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [debouncedSearchTerm, data]);

  // Nuova funzione per gestire il cambio dello stato dell'ordine
  const handleOrderStatusChange = (status: string) => {
    setCurrentPage(1);
    setSessionvrStatus(status);
  };

  const changeSort = (key: keyof MyData) => {
    setSortConfig(currentSortConfig => {
      if (currentSortConfig.key === key) {
        return { key, direction: currentSortConfig.direction === 'asc' ? 'desc' : 'asc' };
      }
      return { key, direction: 'asc' };
    });
  };

  /*const exportDataToCSV = () => {
    const csv = Papa.unparse(filteredData); // Usa filteredData qui
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'Data.csv');
  };*/

  const exportDataToXLSX = (status: string) => {
    // 1. Prepara i dati raw
    let dataToExport = allData;
    if (status !== 'Tutti') {
      dataToExport = dataToExport.filter(s => s.Stato === status);
    }

    // 🔸 Scarta i record senza Stato
    dataToExport = dataToExport.filter(s => s.Stato != null)
  
    // 2. Definisci l’ordine e le etichette delle colonne
    const headers = ([
      { key: 'ID_Sessione_VR',    label: 'ID SESSIONE VR' },
      { key: 'Nome_formatore',    label: 'NOME FORMATORE' },
      { key: 'Cognome_formatore',    label: 'COGNOME FORMATORE' },
      { key: 'Discenti_associati', label: 'N° DISCENTI ASSOCIATI' },
      { key: 'Numero_partecipanti',   label: 'N° PARTECIPANTI' },
      { key: 'Data_inizio',  label: 'DATA INIZIO' },
      // rami condizionali
      ...(status === 'Tutti'
        ? [{ key: 'Stato' as keyof MyData, label: 'STATO ORDINE' }]
        : []),
    ] as { key: keyof MyData; label: string }[]);
  
    // 3. Mappa i dati in array di oggetti con le etichette
    const sheetData = dataToExport.map(row =>
      headers.reduce((acc, h) => {
        let value = row[h.key];
        // Se vuoi convertire le date in veri Date per Excel:
        if (h.key.startsWith('Data_') && typeof value === 'string') {
          const parsed = dayjs(value, 'DD/MM/YYYY', true); // strict mode
        
          acc[h.label] = parsed.isValid() ? parsed.toDate() : value;
        } else {
          acc[h.label] = value;
        }
        return acc;
      }, {} as Record<string, any>)
    );
  
    // 4. Crea workbook e worksheet
    const ws = XLSX.utils.json_to_sheet(sheetData, { header: headers.map(h => h.label), dateNF: 'dd/mm/yyyy' });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sessioni VR');
  
    // 5. Esporta come array e salva
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `Info_SessioniVR-${status}.xlsx`);
  }

  /* Generatore report PDF */
  const generatePDF = async (recordId: string, terminata: boolean) => {
    try {
      const inputReport = { sessionvrID: recordId, terminata: terminata };

      // Chiamata API per ottenere i dati
      const { theoreticalResults, practicalResults } = await detailsReport(inputReport);

      // Verifica se ci sono risultati teorici
      const hasTheoreticalResults = theoreticalResults && theoreticalResults.length > 0;

      // Raggruppa i risultati per simulazione
      const groupedResults: any = {};
      theoreticalResults.forEach((result: any) => {
        if (!groupedResults[result.Simulazione]) {
          groupedResults[result.Simulazione] = { theoretical: [], practical: [] };
        }
        groupedResults[result.Simulazione].theoretical.push(result);
      });

      practicalResults.forEach((result: any) => {
        if (!groupedResults[result.Simulazione]) {
          groupedResults[result.Simulazione] = { theoretical: [], practical: [] };
        }
        groupedResults[result.Simulazione].practical.push(result);
      });

      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginLeft = 10;
      const marginRight = 10;
      const maxWidth = pageWidth - marginLeft - marginRight;
      const lineHeight = 10;
      const spaceBetweenQuestions = 5;
      const spaceAfterQuestion = 3;
      let yPosition = 10;
      let hasContent = false;

      const logo = 'data:image/png;base64,' + caskyBase64;
      const topMargin = 10;
      const logoWidth = 20;
      const logoHeight = 20;
      const logoX = pageWidth - logoWidth - 10;
      const logoY = pageHeight - logoHeight - 10;

      const bottomMargin = topMargin + logoHeight + lineHeight;

      const addFooter = () => {
        doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);
        hasContent = true;
      };

      const checkAndAddPage = (neededSpace:any) => {
        if (yPosition + neededSpace > pageHeight - bottomMargin) {
          if (yPosition > topMargin) {
            doc.addPage();
            yPosition = topMargin;
          }
        }
      };

      const handleTextPlacement = (text: any, xPosition: any, maxWidth: any, fontSize: any, color: any, isQuestion = false, extraSpaceNeeded = 0) => {
        doc.setFontSize(fontSize);
        doc.setTextColor(color.r, color.g, color.b);
        const lines = doc.splitTextToSize(text, maxWidth);

        const neededSpace = lines.length * lineHeight + (isQuestion ? spaceAfterQuestion : 0) + extraSpaceNeeded;
        checkAndAddPage(neededSpace);

        lines.forEach((line: any) => {
          doc.text(line, xPosition, yPosition);
          yPosition += lineHeight;
        });

        if (isQuestion) {
          yPosition += spaceAfterQuestion;
        }
        addFooter();
        hasContent = true;
      };

      // Se ci sono risultati teorici, aggiungi la parte teorica
      if (hasTheoreticalResults) {
        Object.keys(groupedResults).forEach(simulazione => {
          const results = groupedResults[simulazione];

          results.theoretical.forEach((result: any, index: any) => {
            if (index > 0) {
              doc.addPage();
              yPosition = 10;
            }

            let extraSpaceForAnswers = 0;
            let correctAnswersCount = 0;
            let totalQuestionsCount = result.RisultatoQuizTeoria.domande.length;

            const scoreTxt  = `Punteggio ${correctAnswersCount}/${totalQuestionsCount}`;
            const scoreFont = 12;

            result.RisultatoQuizTeoria.domande.forEach((domanda: any) => {
              const tutteFalse = domanda.risposte.every((risposta: any) => !risposta.sceltaUtente);
              if (tutteFalse) {
                totalQuestionsCount--;
                return;
              }

              domanda.risposte.forEach((risposta: any) => {
                const linesForAnswer = doc.splitTextToSize(`- ${risposta.testo}`, maxWidth - 5);
                extraSpaceForAnswers += linesForAnswer.length * lineHeight;
              });
              extraSpaceForAnswers += spaceBetweenQuestions;

              const userAnswer = domanda.risposte.filter((risposta: any) => risposta.sceltaUtente);
              if (userAnswer.length === 1 && userAnswer[0].corretta) {
                correctAnswersCount++;
              }
            });

            doc.setFontSize(12);
            doc.setTextColor(0, 0, 0);
            doc.text(`Punteggio ${correctAnswersCount}/${totalQuestionsCount}`, pageWidth - marginRight, yPosition, { align: 'right' });
            addFooter();

            const reservedRight = doc.getStringUnitWidth(scoreTxt) * scoreFont / doc.internal.scaleFactor + 5;
            const titleMaxWidth = maxWidth - reservedRight;

            handleTextPlacement(
              `${result.Nome} ${result.Cognome} - ${result.Simulazione} - ${result.Livello}`,
              marginLeft,
              titleMaxWidth,
              18,
              { r: 0, g: 0, b: 0 },
              true,
              extraSpaceForAnswers
            );

            result.RisultatoQuizTeoria.domande.forEach((domanda: any, index: any) => {
              if (domanda.risposte.every((risposta: any) => !risposta.sceltaUtente)) {
                return;
              }

              const newMaxWidth = maxWidth - 30;
              const spaceBefore = index > 0 ? spaceBetweenQuestions : 0;

              // Calcola l'altezza esatta del blocco domanda + risposte (stesso font e stesse
              // larghezze usate in fase di scrittura), così il blocco non viene spezzato tra due pagine
              doc.setFontSize(12);
              const linesForQuestion = doc.splitTextToSize(domanda.testo, newMaxWidth);
              // testo domanda + spazio dopo la domanda + riga del simbolo V/X (-6 + lineHeight)
              let neededSpace = linesForQuestion.length * lineHeight + spaceAfterQuestion + (lineHeight - 6);

              domanda.risposte.forEach((risposta: any) => {
                const linesForAnswer = doc.splitTextToSize(`- ${risposta.testo}`, maxWidth - 5);
                neededSpace += linesForAnswer.length * lineHeight;
              });

              // Stesso limite inferiore usato da handleTextPlacement: se il blocco non entra, va tutto
              // sulla pagina successiva (se è più alto di una pagina intera viene comunque spezzato)
              checkAndAddPage(spaceBefore + neededSpace);

              if (yPosition > topMargin) yPosition += spaceBefore;

              const isCorrect = domanda.risposte.some((risposta: any) => risposta.sceltaUtente && risposta.corretta);
              const symbol = isCorrect ? ' V' : ' X';
              const color = isCorrect ? { r: 0, g: 128, b: 0 } : { r: 255, g: 0, b: 0 };

              handleTextPlacement(
                domanda.testo,
                marginLeft,
                newMaxWidth,
                12,
                { r: 0, g: 0, b: 0 },
                true
              );

              yPosition -= 6;
              doc.setTextColor(color.r, color.g, color.b);
              doc.text(symbol, marginLeft + maxWidth - 10, yPosition);
              yPosition += lineHeight;

              domanda.risposte.forEach((risposta: any) => {
                let rispostaColor = { r: 0, g: 0, b: 0 };
                if (risposta.sceltaUtente && risposta.corretta) {
                  rispostaColor = { r: 0, g: 128, b: 0 };
                } else if (risposta.sceltaUtente && !risposta.corretta) {
                  rispostaColor = { r: 255, g: 0, b: 0 };
                } else if (!risposta.sceltaUtente && risposta.corretta) {
                  rispostaColor = { r: 0, g: 128, b: 0 };
                }

                handleTextPlacement(
                  `- ${risposta.testo}`,
                  marginLeft + 5,
                  maxWidth - 5,
                  12,
                  rispostaColor
                );
              });
            });
          });
        });

        // Aggiungi una nuova pagina se ci sono risultati pratici
        if (practicalResults.length > 0) {
          doc.addPage();
          yPosition = 10;
        }
      }

      if (practicalResults.length > 0) {
        yPosition = 10;

        practicalResults.forEach((result: any) => {
          handleTextPlacement(
            `${result.Nome} ${result.Cognome} - ${result.Simulazione} - ${result.Livello} ---> ${result.Punteggio}`,
            marginLeft,
            maxWidth,
            14,
            { r: 0, g: 0, b: 0 }
          );
        });
      }

      if (!hasContent) {
        doc.deletePage(1);
      }

      doc.save('report-sessione-vr.pdf');
    } catch (error) {
      console.error("Errore nella generazione del PDF:", error);
    }
};

  const onGenerateReport = async (recordId:string, terminata:boolean) => {
    generatePDF(recordId, terminata);
  };

  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
  
    tooltipTriggerList.forEach((tooltipTriggerEl: any) => {
      new Tooltip(tooltipTriggerEl);
    });
  }, [filteredData, data, sortedData]);
  
  return (
    <div className={`card ${className}`}>
      {/* begin::Barra ricerca */}
      <div className='card-header border-0 pt-6'>
      <UsersListSearchComponent setParentSearchTerm={setSearchTerm} />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Export */}
        <button type='button' className='btn btn-light-primary me-3 no-margin' onClick={() => setShowExportSessionsVRModal(true)}>
          <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
          Export
        </button>
        {/* end::Export */}
      </div>
      {/* end::Card toolbar */}
      </div>
      {/* end::Barra ricerca */}
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Storico Sessioni VR</span>
          <span className='text-muted mt-1 fw-semibold fs-7'></span>
        </h3>
        <div className='card-toolbar'>
          <ul className='nav'>
            <li className='nav-item'>
              <a
                className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-attivo fw-bold px-4 me-1 ${sessionvrStatus === 'Aperta' ? 'active' : ''}`}
                onClick={() => handleOrderStatusChange('Aperta')}
              >
                Aperta ({stateCounts['Aperta'] || 0})
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-ricevuto fw-bold px-4 me-1 ${sessionvrStatus === 'Chiusa' ? 'active' : ''}`}
                onClick={() => handleOrderStatusChange('Chiusa')}
              >
                Chiusa ({stateCounts['Chiusa'] || 0})
              </a>
            </li>
          </ul>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        <div className='tab-content'>
          {/* begin::Tap pane */}
          <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                {/* begin::Table head */}
                <thead>
                  <tr className='border-0'>
                    <th className='p-0 w-1px'></th>
                    <th className='p-0 min-w-150px th-padding text-muted fw-bold text-head' onClick={() => changeSort('ID_Sessione_VR')}>Sessione VR</th>
                    <th className='p-0 min-w-150px th-padding text-muted fw-bold text-head' onClick={() => changeSort('Nome_formatore')}>Nome formatore</th>
                    <th className='p-0 min-w-150px th-padding text-muted fw-bold text-head' onClick={() => changeSort('Cognome_formatore')}>Cognome formatore</th>
                    <th className='p-0 min-w-150px th-padding text-muted fw-bold text-head' onClick={() => changeSort('Discenti_associati')}>N° Discenti associati
                      <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Discenti loggati alla sessione che non hanno completato alcun livello'
                      ></i>
                    </th>
                    <th className='p-0 min-w-150px th-padding text-muted fw-bold text-head' onClick={() => changeSort('Numero_partecipanti')}>N° partecipanti
                      <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Discenti loggati alla sessione che hanno effettivamente completato dei livelli'
                      ></i>
                    </th>
                    <th className='p-0 min-w-150px th-padding text-muted fw-bold text-head' onClick={() => changeSort('Data_inizio')}>Data inizio</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                {sortedData.slice(start, end).map(item => (
                    <tr key={item.ID_Sessione_VR}>
                      <td></td>
                      <td style={{ fontSize: "1.15rem" }} className='fw-semibold'>{item.ID_Sessione_VR}</td>
                      <td className='text-body fw-semibold'>{item.Nome_formatore}</td>
                      <td className='text-body fw-semibold'>{item.Cognome_formatore}</td>
                      <td className='text-body fw-semibold'>{item.Discenti_associati}</td>
                      <td className='text-body fw-semibold'>{item.Numero_partecipanti}</td>
                      <td className='text-body fw-semibold'>{item.Data_inizio}</td>
                      {/*<td className='text-end'>
                        <span className={`badge ${item.Stato_Ordine === "Ricevuto" ? "badge-light-ricevuto" : ""} ${item.Stato_Ordine === "In lavorazione" ? "badge-light-inlavorazione" : ""} 
                        ${item.Stato_Ordine === "Pronto" ? "badge-light-pronto" : ""} ${item.Stato_Ordine === "Spedito" ? "badge-light-spedito" : ""} ${item.Stato_Ordine === "Attivo" ? "badge-light-attivo" : ""} 
                        ${item.Stato_Ordine === "In scadenza" ? "badge-light-inscadenza" : ""} ${item.Stato_Ordine === "Scaduto" ? "badge-light-scaduto" : ""} 
                        ${item.Stato_Ordine === "Inattivo" ? "badge-light-inattivo" : ""}`}>
                          {item.Stato_Ordine}
                        </span>
                      </td>*/}
                      <td className='text-end'>
                        <div className='btn-group'>
                          <button
                            type='button'
                            className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                            data-bs-toggle='dropdown'
                            aria-expanded='false'
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen052.svg'
                              className='svg-icon-2'
                            />
                          </button>
                          <ul className='dropdown-menu custom-dropdown-menu'>
                            <li className='menu-item px-3'>
                              <a className='dropdown-item menu-item px-3' onClick={() => handleRowClick('view-details', item.ID_Sessione_VR, item.Terminata)}>
                                Dettagli
                              </a>
                            </li>               
                            {item.Stato === 'Aperta' && (
                              <li className='menu-item px-3'>
                                <a className='dropdown-item menu-item px-3' onClick={() => handleRowClick('edit-sessionvr', item.ID_Sessione_VR, item.Terminata)}>
                                  Modifica
                                </a>
                              </li>
                            )}
                            <li className='menu-item px-3'>
                              <a className='dropdown-item menu-item px-3' onClick={() => handleRowClick('delete-sessionvr', item.ID_Sessione_VR, item.Terminata)}>
                                Elimina
                              </a>
                            </li>
                            {item.Stato === 'Aperta' && (
                              <li className='menu-item px-3'>
                                <a className='dropdown-item menu-item px-3' onClick={() => handleRowClick('end-sessionvr-and-generate-report', item.ID_Sessione_VR, item.Terminata)}>
                                  Termina e Genera report
                                </a>
                              </li>
                            )}
                            {item.Stato === 'Chiusa' && (
                              <li className='menu-item px-3'>
                                <a className='dropdown-item menu-item px-3' onClick={() => handleRowClick('generate-report', item.ID_Sessione_VR, item.Terminata)}>
                                  Genera report
                                </a>
                              </li>
                            )}
                          </ul>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
                {/* end::Table body */}
              </table>
            </div>
            {/* end::Table */}
            <UsersListPagination
              totalItems={filteredData.length}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
            />
          </div>
          {/* end::Tap pane */}
        </div>
      </div>
      {/* end::Body */}
      <ExportSessionsVRModal
        show={showExportSessionsVRModal}
        onClose={() => setShowExportSessionsVRModal(false)}
        exportStatus={exportStatus}
        setExportStatus={setExportStatus}
        onExport={() => exportDataToXLSX(exportStatus)}
      />
      {selectedRecordId !== null && (
        <>
        <ViewDetailsSessionVR show={showModal} handleClose={handleCloseModal} recordId={selectedRecordId}/>
        <EditSessionVRAperta show={showEditModal2} handleClose={handleCloseEditModal2} recordId={selectedRecordId}/>
        <DeleteSessionVR show={showDeleteModal} handleClose={handleCloseDeleteModal} recordId={selectedRecordId}/>
        <GenerateReport show={showGenerateReportModal} handleClose={handleCloseGenerateReportModal} recordId={selectedRecordId} terminata={selectedTerminata} onGenerateReport={onGenerateReport} />
        <EndSessionVRAndGenerateReport show={showEndSessionVRAndGenerateReportModal} handleClose={handleCloseEndSessionVRAndGenerateReportModal} recordId={selectedRecordId} terminata={selectedTerminata} onGenerateReport={onGenerateReport} />
        </>
      )}
    </div>
  )
}

export {StoricoSessioniVRWidget}
